import axios from "axios";
import { authService } from "./authService";

const env = process.env.REACT_APP_ENVIRONMENT;
const apiBaseUrl =
  env === "LOCAL"
    ? process.env.REACT_APP_BACKEND_URL_LOCAL
    : process.env.REACT_APP_BACKEND_URL_PRODUCTION;

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  headers: { "Content-Type": "application/json" },
  timeout: 90000,
});

apiClient.interceptors.request.use(async (config) => {
  const token = await authService.acquireToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

class CalendarService {
  getNonworkableDays = async () => {
    const { data } = await apiClient.get("/api/nonworkable_days");
    return data.items;
  };

  createNonworkableDay = async (date, label) => {
    try {
      const { data } = await apiClient.post("/api/nonworkable_days", {
        date,
        label,
      });
      return data;
    } catch (err) {
      const msg = err.response?.data?.detail || "Failed to save date";
      throw new Error(msg);
    }
  };

  deleteNonworkableDay = async (date) => {
    const res = await apiClient.delete(`/api/nonworkable_days/${date}`);
    return res.status === 204 ? { ok: true } : { ok: false };
  };
}

export const calendarService = new CalendarService();
